import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query'
import { monitorException, setMonitoredContext } from '@BUP/services/monitor'
import { reportErrorOnce } from '@BUP/services/monitor/reportErrorOnce'

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      reportErrorOnce(error, () => {
        setMonitoredContext('react-query', { scope: 'query', key: query.queryKey, meta: query.meta })
        monitorException(error)
      })
    }
  }),
  mutationCache: new MutationCache({
    onError: (error, variables, context, mutation) => {
      reportErrorOnce(error, () => {
        setMonitoredContext('react-query', {
          scope: 'mutation',
          key: mutation.options?.meta?.mutationKey,
          variables,
          context
        })
        monitorException(error)
      })
    }
  }),
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // cache fresco por 5 minutos
      gcTime: 5 * 60 * 1000, // mantiene el cache 5 min después de inactividad
      refetchOnWindowFocus: false, // evita refetch al volver a la pestaña
      refetchOnMount: false, // evita refetch al remontar componente
      refetchOnReconnect: true, // permite refetch si vuelve la conexión
      retry: 1, // reintenta solo una vez si falla
      mutations: { retry: false, meta: { reportToSentry: true } }
    }
  }
})

export default queryClient
